import React, { useState } from "react";
import getClasses from "../../../../utils/getClasses";
require("./CustomToggle.scss");

interface IToggle {
  label: string;
  value: boolean;
  onChange: () => void;
}
export const CustomToggle = ({ label, value, onChange }: IToggle) => {
  return (
    <div className="custom-toggle form-group right">
      <label className="toggle">
        <input
          className={getClasses({'checked':value})}
          checked={value}
          onChange={onChange}
          type="checkbox"
        />
        <span className="slider"></span>
      </label>
      <span className="label form-control-label">{label}</span>
    </div>
  );
};
